module.exports = __webpack_public_path__ + "static/media/revery-1.3a81316b.jpg";